// extracted by mini-css-extract-plugin
module.exports = {"container":"VideoSection_container__2WihL","aboutSection":"VideoSection_aboutSection__hB15k","videoSection":"VideoSection_videoSection__3CjFz"};